import React from "react";
import { Link } from "react-router-dom";
import '../App.css';
const Result = ({ animes, anime }) => {
  if (!animes || !anime) {
    return (
      <div className="result">
        <h1>Error... Please try Again</h1>
        <div>
          <img
            className="myimg img-fluid"
            src="/error.jpg"
            alt="anime poster"
          />
          <h3 className="resultHeading">Here are your results:</h3>
        </div>
        <button className="btn btn-primary">
          <Link to="/">Retry</Link>
        </button>
      </div>
    );
  }
  const shareResult = () => {
    const shareText = "I took a quiz and found out my reincartion anime world!";
    const url = encodeURIComponent(window.location.href);
    const text = encodeURIComponent(shareText);

    const twitterShare = `https://twitter.com/intent/tweet?text=${text}&url=${url}`;
    const facebookShare = `https://www.facebook.com/sharer/sharer.php?u=${url}&quote=${text}`;
    const redditShare = `https://www.reddit.com/submit?url=${url}&title=${text}`;
    const whatsappShare = `https://api.whatsapp.com/send?text=${text} ${url}`;

    return (
      <div className="share-buttons">
        <a href={twitterShare} target="_blank" rel="noopener noreferrer">
          <i className="bi bi-twitter-x text-dark "></i>
        </a>
        <a href={facebookShare} target="_blank" rel="noopener noreferrer">
          <i className="bi bi-facebook text-primary"></i>
        </a>
        <a href={redditShare} target="_blank" rel="noopener noreferrer">
          <i className="bi bi-reddit text-danger"></i>
        </a>
        <a href={whatsappShare} target="_blank" rel="noopener noreferrer">
          <i className="bi bi-whatsapp text-success"></i>
        </a>
      </div>
    );
  };

  return (
    <div className="result">
      {anime === "F" ? (
        <h2>Error.. Please Try Again!</h2>
      ) : (
        <div>
          <img
            className="img-fluid chris"
            src="/home/christmas.png"
            alt="anime poster"

          />
          <h3>Here are your results:</h3>
        </div>
      )}

      <div className="container w-100">
        {animes[anime].map((a, idx) => (
          <img
            key={idx}
            className="myimg img-fluid"
            src={a}
            alt="This is an Anime poster"
          />
        ))
        }
      </div>

      {anime === "F" ? (
        
          <Link className="btn" to='/'>Try again</Link>
        
      ) : (
        <>
          <h3>Share with your Friends : </h3>
          {shareResult()}
        </>
      )}
    </div>
  );
};

export default Result;
